import React, {useState, useCallback, useContext, useEffect} from 'react';
import { View } from 'react-native';
import { useForm } from 'react-hook-form';
import { useMutation, useLazyQuery } from '@apollo/client';

import { AuthContext } from 'app/src/contexts/AuthContext';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { CREATE_FEE, SELECTS } from './queries';
import { formatAssetNameForSelect } from '../../utils/formatAssetName';
import Autocomplete from '../Autocomplete';
import { CREATE_FEE_ESTIMATE } from './FeeEstimates/queries';

const NewFee = ({
  setShowModal, refetch, knownAsset, feeEstimate, fromSalesProcess
}) => {
  const { feeTypes } = useContext(AuthContext);
  const [submitting, setSubmitting] = useState();
  const [asset, setAsset] = useState(knownAsset);
  const [assets, setAssets] = useState();
  const [userOptions, setUserOptions] = useState();
  const [createFee] = useMutation(CREATE_FEE, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const [createFeeEstimate] = useMutation(CREATE_FEE_ESTIMATE, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const [ loadSelectOptions, { loading: loading, data: data } ] =
    useLazyQuery(SELECTS, {
      onCompleted: () => setUserOptions(data?.users)
    }
  );

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    if(feeEstimate) {
      createFeeEstimate({variables: input})
    }else {
      createFee({ variables: input });
    }
  });

  const { control, handleSubmit, register, setValue, watch, formState: { errors } } = useForm({
    defaultValues: {
      type: '',
      buyerFee: false,
      assetId: asset?.id || '',
      saleAssetId: '',
      amount: '',
      description: '',
      feeEstimate: feeEstimate,
      acceptedById: '',
      acceptedByMethod: ''
    }
  });

  const watchFeeType = watch('type');

  useEffect(() => {
    if(fromSalesProcess && !userOptions) {
      loadSelectOptions();
    }
  }, [])

  useEffect(() => {
    if(watchFeeType === 'Inspection' &&
      asset?.seller?.inspectionFeeAmount && asset?.seller?.inspectionFeeAmount > 0
    ) {
      setValue('amount', asset?.seller?.inspectionFeeAmount)
    }
  }, [watchFeeType]);

  return (
    <View>
      {submitting ?
        <DataState.Loading /> :
        <View>
          {/* <Input.Text
            label="Type:"
            name="type"
            control={control}
            errors={errors}
            id="type"
            {...register("type", {
              required: "Type is required",
              validate: {
                maxLength: (v) =>
                  v.length <= 10 || "The type should have at most 10 characters",
              },
            })}
          /> */}
          <Input.Picker
            label="Type:"
            name="type"
            options={feeTypes}
            control={control}
            errors={errors}
          />
          {/* <Input.Checkbox
            label="Buyer Fee?"
            name="buyerFee"
            control={control}
            errors={errors}
          /> */}
          {/* <Input.Picker
            label="Asset:"
            name="assetId"
            options={assets}
            control={control}
            errors={errors}
          /> */}
          { asset ?
            <></>
            :
            <Autocomplete
              label={'Asset'}
              placeHolder={''}
              resource={'Asset'}
              options={assets}
              setValue={setValue}
              name='assetId'
              {...register("fee", {
                required: "Required",
              })}
            />
          }
          <Input.Currency
            label="Amount:"
            name="amount"
            control={control}
            errors={errors}
            id="amount"
            {...register("amount", {
              required: "Amount is required",
              maxLength: { value: 8, message: 'Must be less than $1,000,000' },
              validate: {
                matchPattern: (v) =>
                  /\d{1,10}(\.{1}\d{1,2}){0,1}?$/.test(v) ||
                  "Please use number only without commas",
              },
            })}
          />
          <Input.Text
            label="Description:"
            name="description"
            control={control}
            errors={errors}
          />
          {fromSalesProcess &&
            <View>
              <Input.Picker
                label="Accepted By:"
                name="acceptedById"
                options={
                  userOptions?.map(user => { return { value: user.id, label: user.fullName }})
                }
                control={control}
                errors={errors}
              />
              <Input.Picker
                label="Accepted Method:"
                name="acceptedByMethod"
                options={
                  ['Email', 'Call'].map(type => { return { value: type, label: type }})
                }
                control={control}
                errors={errors}
              />
            </View>
          }
          <ButtonContainer>
            <ButtonGroup>
              <Button
                label={feeEstimate ? "Create Fee Estimate" : "Create Fee"}
                onPress={handleSubmit(onSubmit)}
              />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewFee;
